import { c as _c } from "react/compiler-runtime";
import type { TypographyProps } from '@mui/material';
import Typography from '@mui/material/Typography';
const colors = {
  full: '#333',
  muted: '#888'
};
const convertToCaps = (text: string | number) => {
  if (typeof text === 'string') {
    return text.toUpperCase();
  }
  return text;
};
type CommonTitleProps = {
  text: string | number;
  muted?: boolean;
  caps?: boolean;
} & TypographyProps;
export const ExtraLarge: React.FC<CommonTitleProps> = t0 => {
  const $ = _c(16);
  let caps;
  let muted;
  let props;
  let sx;
  let text;
  if ($[0] !== t0) {
    ({
      caps,
      text,
      muted,
      sx,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = caps;
    $[2] = muted;
    $[3] = props;
    $[4] = sx;
    $[5] = text;
  } else {
    caps = $[1];
    muted = $[2];
    props = $[3];
    sx = $[4];
    text = $[5];
  }
  const t1 = muted ? colors.muted : colors.full;
  let t2;
  if ($[6] !== sx || $[7] !== t1) {
    t2 = {
      display: "inline",
      color: t1,
      fontWeight: "600",
      ...sx
    };
    $[6] = sx;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== caps || $[10] !== text) {
    t3 = caps ? convertToCaps(text) : text;
    $[9] = caps;
    $[10] = text;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== props || $[13] !== t2 || $[14] !== t3) {
    t4 = <Typography variant="h1" sx={t2} {...props}>{t3}</Typography>;
    $[12] = props;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export const Large: React.FC<CommonTitleProps> = t0 => {
  const $ = _c(16);
  let caps;
  let muted;
  let props;
  let sx;
  let text;
  if ($[0] !== t0) {
    ({
      caps,
      text,
      muted,
      sx,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = caps;
    $[2] = muted;
    $[3] = props;
    $[4] = sx;
    $[5] = text;
  } else {
    caps = $[1];
    muted = $[2];
    props = $[3];
    sx = $[4];
    text = $[5];
  }
  const t1 = muted ? colors.muted : colors.full;
  let t2;
  if ($[6] !== sx || $[7] !== t1) {
    t2 = {
      display: "inline",
      color: t1,
      fontWeight: "600",
      ...sx
    };
    $[6] = sx;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== caps || $[10] !== text) {
    t3 = caps ? convertToCaps(text) : text;
    $[9] = caps;
    $[10] = text;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== props || $[13] !== t2 || $[14] !== t3) {
    t4 = <Typography variant="h2" sx={t2} {...props}>{t3}</Typography>;
    $[12] = props;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export const Medium: React.FC<CommonTitleProps> = t0 => {
  const $ = _c(16);
  let caps;
  let muted;
  let props;
  let sx;
  let text;
  if ($[0] !== t0) {
    ({
      caps,
      text,
      muted,
      sx,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = caps;
    $[2] = muted;
    $[3] = props;
    $[4] = sx;
    $[5] = text;
  } else {
    caps = $[1];
    muted = $[2];
    props = $[3];
    sx = $[4];
    text = $[5];
  }
  const t1 = muted ? colors.muted : colors.full;
  let t2;
  if ($[6] !== sx || $[7] !== t1) {
    t2 = {
      display: "inline",
      color: t1,
      fontWeight: "600",
      ...sx
    };
    $[6] = sx;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== caps || $[10] !== text) {
    t3 = caps ? convertToCaps(text) : text;
    $[9] = caps;
    $[10] = text;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== props || $[13] !== t2 || $[14] !== t3) {
    t4 = <Typography variant="h3" sx={t2} {...props}>{t3}</Typography>;
    $[12] = props;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export const Regular: React.FC<CommonTitleProps> = t0 => {
  const $ = _c(16);
  let caps;
  let muted;
  let props;
  let sx;
  let text;
  if ($[0] !== t0) {
    ({
      caps,
      text,
      muted,
      sx,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = caps;
    $[2] = muted;
    $[3] = props;
    $[4] = sx;
    $[5] = text;
  } else {
    caps = $[1];
    muted = $[2];
    props = $[3];
    sx = $[4];
    text = $[5];
  }
  const t1 = muted ? colors.muted : colors.full;
  let t2;
  if ($[6] !== sx || $[7] !== t1) {
    t2 = {
      display: "inline",
      color: t1,
      fontWeight: "600",
      ...sx
    };
    $[6] = sx;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== caps || $[10] !== text) {
    t3 = caps ? convertToCaps(text) : text;
    $[9] = caps;
    $[10] = text;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== props || $[13] !== t2 || $[14] !== t3) {
    t4 = <Typography variant="h4" sx={t2} {...props}>{t3}</Typography>;
    $[12] = props;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export const Small: React.FC<CommonTitleProps> = t0 => {
  const $ = _c(16);
  let caps;
  let muted;
  let props;
  let sx;
  let text;
  if ($[0] !== t0) {
    ({
      caps,
      text,
      muted,
      sx,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = caps;
    $[2] = muted;
    $[3] = props;
    $[4] = sx;
    $[5] = text;
  } else {
    caps = $[1];
    muted = $[2];
    props = $[3];
    sx = $[4];
    text = $[5];
  }
  const t1 = muted ? colors.muted : colors.full;
  let t2;
  if ($[6] !== sx || $[7] !== t1) {
    t2 = {
      display: "inline",
      color: t1,
      fontWeight: "600",
      ...sx
    };
    $[6] = sx;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== caps || $[10] !== text) {
    t3 = caps ? convertToCaps(text) : text;
    $[9] = caps;
    $[10] = text;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== props || $[13] !== t2 || $[14] !== t3) {
    t4 = <Typography variant="h5" sx={t2} {...props}>{t3}</Typography>;
    $[12] = props;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export const ExtraSmall: React.FC<CommonTitleProps> = t0 => {
  const $ = _c(16);
  let caps;
  let muted;
  let props;
  let sx;
  let text;
  if ($[0] !== t0) {
    ({
      caps,
      text,
      muted,
      sx,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = caps;
    $[2] = muted;
    $[3] = props;
    $[4] = sx;
    $[5] = text;
  } else {
    caps = $[1];
    muted = $[2];
    props = $[3];
    sx = $[4];
    text = $[5];
  }
  const t1 = muted ? colors.muted : colors.full;
  let t2;
  if ($[6] !== sx || $[7] !== t1) {
    t2 = {
      display: "inline",
      color: t1,
      fontWeight: "600",
      ...sx
    };
    $[6] = sx;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== caps || $[10] !== text) {
    t3 = caps ? convertToCaps(text) : text;
    $[9] = caps;
    $[10] = text;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== props || $[13] !== t2 || $[14] !== t3) {
    t4 = <Typography variant="h6" sx={t2} {...props}>{t3}</Typography>;
    $[12] = props;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export const Tiny: React.FC<CommonTitleProps> = t0 => {
  const $ = _c(16);
  let caps;
  let muted;
  let props;
  let sx;
  let text;
  if ($[0] !== t0) {
    ({
      caps,
      text,
      muted,
      sx,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = caps;
    $[2] = muted;
    $[3] = props;
    $[4] = sx;
    $[5] = text;
  } else {
    caps = $[1];
    muted = $[2];
    props = $[3];
    sx = $[4];
    text = $[5];
  }
  const t1 = muted ? colors.muted : colors.full;
  let t2;
  if ($[6] !== sx || $[7] !== t1) {
    t2 = {
      display: "inline",
      color: t1,
      ...sx
    };
    $[6] = sx;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== caps || $[10] !== text) {
    t3 = caps ? convertToCaps(text) : text;
    $[9] = caps;
    $[10] = text;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== props || $[13] !== t2 || $[14] !== t3) {
    t4 = <Typography variant="caption" sx={t2} {...props}>{t3}</Typography>;
    $[12] = props;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export const Title = {
  ExtraLarge,
  Large,
  Medium,
  Regular,
  Small,
  ExtraSmall,
  Tiny
};